import "./header.css";
import Logo from "../../../../ui/atoms/logo/Logo";
import MobileButton from "../mobile-buttons/MobileButton";
import LanguageSelector from "../../../../ui/molecules/languages/LanguageSelector";
import { FaRegUser } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const Header = ({ fix }) => {
  const navigate = useNavigate();

  return (
    <header className={fix ? "h-header fixed" : "h-header"}>
      <div className="h-header-container">
        <Logo to={"/"} width={"140px"} />

        <nav className="h-header-nav">
          <MobileButton
            type={"apple"}
            title={"Download on the"}
            subtitle={"App Store"}
            color={"#000"}
          />

          <MobileButton
            type={"google"}
            title={"GET IT ON"}
            subtitle={"Google Play"}
            color={"#000"}
          />

          <div className="h-header-language">
            <LanguageSelector />
          </div>

          <button
            className="h-header-signin"
            onClick={() => navigate("signin", { replace: true })}
          >
            <FaRegUser className="icon" />

            <span>Sign In</span>
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
